<card-component title="Payments">
    <card-content>
        <cdk-table-component
            [displayColumns]="displayColumns"
            [entities]="tableEntities"
            [dataSource]="dataSource"
        ></cdk-table-component>
    </card-content>
</card-component>
